import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center py-20 px-4 md:px-6 overflow-hidden bg-[#0A0A0A]" data-id="element-76">
      {/* Background Gradient */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-[#2563EB]/10 blur-[120px] rounded-full pointer-events-none" data-id="element-77" />

      <div className="max-w-5xl mx-auto w-full text-center relative z-10" data-id="element-78">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="inline-block mb-8" data-id="element-79">
          <span className="px-4 py-1.5 rounded-full border border-gray-800 bg-[#111111] text-xs md:text-sm font-medium text-gray-400 tracking-wider uppercase" data-id="element-80">
            Reset Mental Funcional (RMF)
          </span>
        </motion.div>

        {/* Headlines */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="text-5xl md:text-7xl lg:text-8xl font-black text-white tracking-tight mb-6 leading-[0.95]" data-id="element-81">
          Tienes 7 minutos… <br className="hidden md:block" data-id="element-82" />
          <span className="text-gray-500" data-id="element-83">o pierdes el día.</span>
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="text-xl md:text-3xl font-bold text-[#2563EB] mb-12 max-w-3xl mx-auto" data-id="element-84">
          No necesitas paz. Necesitas un reset operativo.
        </motion.h2>

        {/* Grid Layout for Image + Copy */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16 text-left" data-id="element-85">
          {/* Copy Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4
        }} className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed order-2 lg:order-1" data-id="element-86">
            <p className="font-medium text-white" data-id="element-87">
              Estás a minutos de un meeting.
            </p>
            <p data-id="element-88">O estás por empezar tu shift.</p>
            <p data-id="element-89">Y ya te sientes tarde… aunque apenas va arrancando el día.</p>
            <p data-id="element-90">La cabeza va a mil. El cuerpo está tenso.</p>
            <p className="text-gray-400 italic" data-id="element-91">
              Te notas short. Te molesta todo. Y lo peor: sabes que si entras
              así, vas a improvisar, vas a reaccionar, o vas a decir algo que
              después tienes que arreglar.
            </p>
            <div className="pt-4 border-l-2 border-[#2563EB] pl-6" data-id="element-92">
              <p className="font-bold text-white mb-2" data-id="element-93">
                No necesitas que alguien te diga "respira y piensa positivo".
              </p>
              <p className="text-[#2563EB] font-bold" data-id="element-94">
                Necesitas un protocolo.
              </p>
            </div>
          </motion.div>

          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.5
        }} className="relative order-1 lg:order-2" data-id="element-95">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-[#2563EB]/20 border border-gray-800 bg-[#111]" data-id="element-96">
              <img src="https://cdn.magicpatterns.com/uploads/afjudqefYtRaAcUmKV4Tsa/RESET_OPERATIVO.png" alt="Reset Operativo Product Mockup" className="w-full h-auto object-cover" data-id="element-97" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent opacity-40" data-id="element-98" />
            </div>
          </motion.div>
        </div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} className="flex flex-col items-center gap-4" data-id="element-99">
          <Button size="xl" className="w-full md:w-auto min-w-[320px] animate-pulse-slow" href="https://helproutines.com/cart/44635947597894:1" data-id="element-100">
            Quiero Reset Operativo (7 Min) —{' '}
            <span className="line-through text-gray-400 mr-1" data-id="element-101">$27</span> $6.39
          </Button>
          <p className="text-sm text-gray-500 uppercase tracking-wide" data-id="element-102">
            Pago único • PDF descargable • Sin suscripción
          </p>
        </motion.div>
      </div>
    </section>;
}